import { ActionTypes } from 'src/types/types';

export const FEATURE_NAME = 'attendeesSidebar';

export const actionTypes = {
  CHANGE_ATTENDEES_SIDEBAR_VIEW: `${FEATURE_NAME}/CHANGE_ATTENDEES_SIDEBAR_VIEW`,
  GET_ATTENDEE_DATA: `${FEATURE_NAME}/GET_ATTENDEE_DATA`,
  UPDATE_ATTENDEE_DATA: `${FEATURE_NAME}/UPDATE_ATTENDEE_DATA`,
  DELETE_ATTENDEE_DATA: `${FEATURE_NAME}/DELETE_ATTENDEE_DATA`,
} satisfies ActionTypes<typeof FEATURE_NAME>;
